import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_ENDPOINTS from '../../utils/api';

// Async thunk for uploading media
export const uploadMedia = createAsyncThunk(
  'media/uploadMedia',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_ENDPOINTS.UPLOAD_MEDIA(),
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
      return response.data; // assuming backend returns array of urls
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// Create media slice
const mediaSlice = createSlice({
  name: 'media',
  initialState: {
    mediaUrl: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadMedia.fulfilled, (state, action) => {
        state.loading = false;
        state.mediaUrl = action.payload?.url; // Assuming the API response contains the URL
        state.error = null;
      })
      .addCase(uploadMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to upload media';
      });
  },
});

export default mediaSlice.reducer;
